function sharePage() {
    $('.share-page').dropDownMenu({
        disabled:    false,
        classBtn:    'button-2 button-2--small button-2--no-text',
        independent: false
    });
}
